import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    blankProject: string;
    startFromScratch: string;
    collections: (count: number) => string | React.ReactNode;
    fields: (count: number) => string | React.ReactNode;
    folders: (count: number) => string | React.ReactNode;
    includeSampleContent: string;
    warningButton: string;
    warningDescription: string;
    sampleContentTooltipTitle: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** The title for creating a blank project */
            blankProject: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TemplateRow.blankProject?c=2suf1j4erk9l2", defaultMessage: "Blank Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Section label for blank project templates */
            startFromScratch: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TemplateRow.startFromScratch?c=78gg808j3vot", defaultMessage: "Start from scratch" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Count label for collections included in the template */
            collections: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "TemplateRow.collections?c=754pxf4tooh4", defaultMessage: "{count, plural, one {1 Collection} other {{count} Collections}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Count label for custom fields included in the template */
            fields: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "TemplateRow.fields?c=3lhdln09u1lyo", defaultMessage: "{count, plural, one {1 Field} other {{count} Fields}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Count label for folders included in the template */
            folders: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "TemplateRow.folders?c=28otpx0dyz5di", defaultMessage: "{count, plural, one {1 Folder} other {{count} Folders}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toggle label for including sample content in the new project */
            includeSampleContent: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TemplateRow.includeSampleContent?c=xvbb79nfzip", defaultMessage: "Include Sample Content" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label for the template limit warning */
            warningButton: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TemplateRow.warningButton?c=2bu5tw74q9bww", defaultMessage: "Learn more" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Warning message when template exceeds account limits */
            warningDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TemplateRow.warningDescription?c=2bpgilhnfm2pk", defaultMessage: "This template exceeds your account''s custom field limit." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip text describing sample content restrictions */
            sampleContentTooltipTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TemplateRow.sampleContentTooltipTitle?c=2f4wppoxh3hgo", defaultMessage: "Sample Content may not be used for any commercial purposes." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
